module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.fieldLabel) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.fieldLabel)), (_vm.required) ? _c('span', [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _vm._l((_vm.options), function(option, index) {
    return _c('radio', {
      key: index,
      attrs: {
        "name": _vm.name,
        "option-index": index,
        "option-label": option.label,
        "option-status": option.status
      },
      model: {
        value: (_vm.value),
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ba23388","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edRadio/index.vue
// module id = Uist
// module chunks = 13 14